import TopCommentDesktop from './top-comment-desktop';
import TopCommentMobile from './top-comment-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(TopCommentMobile, TopCommentDesktop);



// WEBPACK FOOTER //
// ./app/components/top-comment/top-comment.js